import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Row, Col } from 'react-bootstrap';
import Button from "../../components/Button/Button.js";
import { ClipLoader } from "react-spinners";
import Cookies from 'js-cookie';
import {word} from "../../word.js";

const ChangeMyData = ({ close, create }) => {
    const [imagePreviewUrl, setImagePreviewUrl] = useState("");
    const [image, setImage] = useState("");
    const [form, setForm] = useState([
        {
            key: 'user.first_name',
            value: '',
            errorMessage: "name_error",
            type: "text",
            label: "",
            valid: true
        },
        {
            key: 'user.last_name',
            value: '',
            errorMessage: "name_error",
            type: "text",
            label: "",
            valid: true
        },
        {
            key: 'phone',
            value: '',
            errorMessage: "phone_error",
            type: "phone",
            label: "",
            valid: true
        },
        {
            key: 'user.email',
            value: '',
            errorMessage: "phone_error",
            type: "email",
            label: "",
            valid: true
        },
        {
            key: 'user.password',
            value: '',
            errorMessage: "phone_error",
            type: "password",
            label: "",
            valid: true
        }
    ]);
    const [submited, setSubmited] = useState(false);
    const [information, setInformation] = useState(null);

    const employee = useSelector(state => state.manager.employee);
    const dispatch = useDispatch();

    useEffect(() => {
        if (employee) {
            setInformation(employee);
            setForm(form => form.map(item => ({
                ...item,
                value: _getValue(employee, item.key) || item.value
            })));
        }
    }, [employee]);

    const keyPress = (e) => {
        if (e.key === "Enter") {
            changeMyDataHandler();
        }
    };

    const _valid = (item) => {
        switch (item.type) {
            case "text":
                item.valid = !(item.value.length < 3 && item.value.length > 0);
                break;
            case "phone":
                let re = /^[0-9]/;
                item.valid = re.test(String(item.value).toLowerCase()) && item.value[0] === '0' && item.value.length === 9;
                break;
            default:
        }
        return item.valid;
    };

    const _renderInput = (item, index) => {
        return (
            <div className='input-validation' key={index}>
                <input
                    type='text'
                    onKeyDown={(e) => keyPress(e)}
                    onChange={(e) => {
                        item.value = e.target.value;
                        item.valid = _valid(item);
                        setForm([...form]);
                    }}
                    onBlur={() => {
                        item.active = true;
                        setForm([...form]);
                    }}
                    onFocus={() => {
                        item.active = true;
                        setForm([...form]);
                    }}
                    placeholder={word[item.key]}
                    name={item.key}
                    value={item.value}
                />
                {(!item.valid && (submited || item.active)) ? <div className='validation'>{word[item.errorMessage]}</div> : null}
            </div>
        );
    };

    const _getValue = (data, key) => {
        let result = data;
        let path = key.split(".");
        for (let index = 0; index < path.length; index++) {
            result = result[path[index]];
        }
        return result === data ? null : result;
    };

    const formValid = (formErrors) => {
        let valid = true;
        Object.values(formErrors).forEach(element => {
            if (element.length > 0) {
                valid = false;
            }
        });
        return valid;
    };

    const changeMyDataHandler = () => {
        const profession = Cookies.get("profession");
        const token = Cookies.get("token");
        const id = Cookies.get("id");

        let formData = new FormData();
        if (image) formData.append("image", image, image.name);
        setSubmited(true);

        form.forEach(item => {
            if (!item.valid && item.value.length === 0) return;
            formData.append(item.key, item.value);
        });

        // changeMyData(formData, token, profession, id)
        //     .then(() => close())
        //     .then(() => {
        //         getMeById(id, token, profession)
        //             .then((getme) => {
        //                 dispatch(employeeAction(getme));
        //             }).catch((error) => console.log(error));
        //     }).catch((error) => {
        //     console.log(error);
        // });
    };

    let $imagePreview = null;
    if (imagePreviewUrl !== "") {
        $imagePreview = (<div className='change-my-img' style={{ backgroundImage: "url(" + imagePreviewUrl + ")" }} />);
    } else {
        if (employee.image) {
            $imagePreview = (<div className='change-my-img' style={{ backgroundImage: "url(" + employee.image + ")" }} />);
        } else {
            $imagePreview = (<i className="fas fa-camera" />);
        }
    }

    if (!employee.url) {
        return (
            <div className='container'>
                <div className='loaderMargin'>
                    <ClipLoader
                        type="Oval"
                        color="#101C2A"
                        size
                    />
                </div>
            </div>
        );
    }

    return (
        <div className='add'>
            <div className="tool-tip-cont">
                <div className="tool-tip">Փակել</div>
                <i className="fas fa-times" onClick={close}/>
            </div>
            <div className='green-top'>
                <Col xs={12} sm={10}> {create}</Col>
            </div>
            <div className='container'>
                <Row className="d-flex justify-content-around">
                    <Col xs={12} sm={10}>
                        <div className='add-img'>
                            <label>
                                <input
                                    type="file"
                                    onChange={(e) => {
                                        let reader = new FileReader();
                                        let file = e.target.files[0] || employee.image;
                                        reader.onloadend = () => {
                                            setImagePreviewUrl(reader.result);
                                            setImage(file);
                                        };
                                        reader.readAsDataURL(file);
                                    }}
                                />
                                <span className='add-span'>{word.add_picture}</span>
                                <div className='add-round-img'>{$imagePreview}</div>
                            </label>
                            {form.map((item, index) => {
                                return _renderInput(item, index);
                            })}
                        </div>
                    </Col>
                </Row>
                <Row className="d-flex ">
                    <Col xs={12} sm={10} className="d-flex align-items-end">
                        <Button
                            buttonStyle="blue-button"
                            onChangeValue={changeMyDataHandler}
                            title={word.confirmed}
                        />
                    </Col>
                </Row>
            </div>
        </div>
    );
};

export default ChangeMyData;
